// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_od-8";
export var editMode = "_od-3";
export var headerRow = "_od-a";
export var headerTitle = "_od-b";
export var product = "_od-1";
export var productDetails = "_od-5";
export var productDivider = "_od-7";
export var productImage = "_od-2";
export var productInfo = "_od-4";
export var productTitle = "_od-6";
export var strikethrough = "_od-9";
export var upsellProductsCard = "_od-0";